export const COLLAPSIBLE_CHARTS_EDITOR_ID = 'header-collapsible-charts-editor'
export const COLLAPSIBLE_METRICS_EDITOR_ID = 'header-collapsible-metrics-editor'
